export const role = {
  ADMIN_USER: "ADMIN_USER", 
  POWER_USER: "POWER_USER", 
  GENERAL_USER: "GENERAL_USER", 
  GUARD_S1: "GUARD_S1", 
  GUARD_S2: "GUARD_S2", 
  GUARD_S3: "GUARD_S3",
  GUARD_S4: "GUARD_S4",
  FINANCIAL: "FINANCIAL",
  AFFAIRS: "AFFAIRS",
  LOGISTIC: "LOGISTIC",
  GUARD_S5: "GUARD_S5",
  GUARD_LEAD: "GUARD_LEAD",
  LOGISTIC_LEAD: "LOGISTIC_LEAD",
  CUSTOMS: "CUSTOMS",
  LOGISTICPLAN_MNG: "LOGISTICPLAN_MNG",
	LOGISTIC_MNG: "LOGISTIC_MNG",
	PRODUCT_MNG: "PRODUCT_MNG"
}
